import { InitSentryForEmber } from '@sentry/ember';

import Application from '@ember/application';
import Resolver from 'ember-resolver';
import loadInitializers from 'ember-load-initializers';
import config from 'sh-www/config/environment';

InitSentryForEmber();

/**
 * This is a temporary workaround to prevent a ReferenceError in tippy.js, because it checks
 * `process.env.NODE_ENV` to determine whether it should show helpful warnings and error messages
 * during development. Ideally, we would use a bundler that could replace references to
 * `process.env.NODE_ENV` with the string of the current environment name, but Ember's toolchain
 * does not offer this type of functionality.
 */
window.process = {
  env: { NODE_ENV: 'production' },
};

export default class App extends Application {
  rootElement = '#SH-app__root';
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;
  Resolver = Resolver;
}

loadInitializers(App, config.modulePrefix);
